import React, { useState, useRef, useEffect } from "react";
import { Calendar } from "lucide-react";
import CalendarPopup from "./CalendarPopup";

const CalendarInput = ({
  label = "Select Order Date",
  value,
  onChange,
  required = false,
  onlyFuture = false,
}) => {
  const [open, setOpen] = useState(false);
  const [error, setError] = useState(""); // ✅ NEW
  const ref = useRef(null);

  useEffect(() => {
    const handler = (e) => {
      if (ref.current && !ref.current.contains(e.target)) {
        setOpen(false);
      }
    };
    document.addEventListener("mousedown", handler);
    return () => document.removeEventListener("mousedown", handler);
  }, []);

  const isPastDate = (selectedDate) => {
    const today = new Date();
    today.setHours(0, 0, 0, 0);

    const picked = new Date(selectedDate);
    picked.setHours(0, 0, 0, 0);

    return picked < today;
  };

  return (
    <div className="relative w-full max-w-sm" ref={ref}>
      {label && (
        <label className="text-sm font-medium text-gray-600 mb-1 block">
          {label}
          {required && <span className="text-red-500 ml-1">*</span>}
        </label>
      )}

      {/* INPUT */}
      <div
        onClick={() => setOpen(true)}
        className={`
          h-11 px-4
          flex items-center justify-between
          rounded-xl border
          bg-white cursor-pointer
          transition
          ${
            error
              ? "border-red-400 focus:ring-2 focus:ring-red-100"
              : "border-gray-200 hover:border-gray-300"
          }
        `}
      >
        <span
          className={`text-sm ${value ? "text-gray-900" : "text-gray-400"}`}
        >
          {value || "Select Order Date"}
        </span>
        <Calendar size={18} className="text-gray-500" />
      </div>

      {/* ERROR MESSAGE */}
      {error && (
        <p className="mt-1 text-xs text-red-500 font-medium">{error}</p>
      )}

      {/* POPUP */}
      {open && (
        <div className="absolute z-50 mt-2">
          <CalendarPopup
            variant="trial"
            onClose={() => setOpen(false)}
            onApply={(date) => {
              if (onlyFuture && isPastDate(date)) {
                setError(
                  "Past dates are not allowed. Please select today or a future date.",
                );
                return;
              }

              setError(""); // clear error if valid
              onChange(date);
              setOpen(false);
            }}
          />
        </div>
      )}
    </div>
  );
};

export default CalendarInput;
